export const Badge = ({ status, className = '' }) => {
  const statusStyles = {
    PENDING: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    RESOLVED: 'bg-green-100 text-green-800 border-green-200',
    REJECTED: 'bg-red-100 text-red-800 border-red-200',
  };

  return (
    <span
      className={`px-3 py-1 text-xs font-semibold rounded-full border ${statusStyles[status]} ${className}`}
    >
      {status}
    </span>
  );
};